export const DROPDOWN_SIDE_OFFSET = 8;
